<div class="flex flex-col gap-3 lg:gap-10 px-4 lg:px-0 lg:max-w-6xl lg:mx-auto py-6 lg:py-12 w-full">
  <!-- 검색 및 TOTAL 영역 -->
  <div class="flex flex-col gap-3 lg:flex-row lg:justify-between lg:items-center">
    <!-- TOTAL -->
    <div class="flex items-center gap-1">
      <span class="text-zinc-800 sb-aggro text-sm font-light">TOTAL</span>
      <span class="text-orange-500 sb-aggro font-light text-sm">{{ totalCount() }}</span>
    </div>

    <!-- 검색창 -->
    <div class="search-box">
      <app-icon name="ic:round-search" class="size-5! text-zinc-400"></app-icon>
      <input type="text" placeholder="검색어를 입력하세요" [value]="query()" (input)="onSearch($event)" />
    </div>
  </div>

  <!-- 보도자료 리스트 -->
  <div class="flex flex-col gap-6">
    @for (news of newsList(); track news.id) {
    <div
      [routerLink]="[news.id]"
      class="flex flex-col gap-2 px-3 py-4 lg:px-4 lg:py-3 border-b border-zinc-100 cursor-pointer lg:gap-3 hover:bg-zinc-50 transition-colors">
      <!-- 모바일 레이아웃 -->
      <div class="flex flex-col gap-2 lg:hidden">
        <h3 class="sb-aggro text-lg text-zinc-800 line-clamp-1 font-light">
          {{ news.title }}
        </h3>
        @if (news.content) {
        <p class="text-sm text-zinc-400 line-clamp-2 leading-relaxed font-medium">
          {{ stripHtml(news.content) }}
        </p>
        }
        <span class="text-sm text-zinc-800 font-medium">
          {{ news.displayDate || news.createdAt | date : 'yyyy.MM.dd' }}
        </span>
      </div>

      <!-- 데스크탑 레이아웃 -->
      <div class="hidden lg:flex justify-between gap-2 items-center">
        <div class="hidden lg:flex lg:flex-col lg:gap-2">
          <div class="flex items-center gap-2 flex-1">
            <h3 class="sb-aggro text-lg font-light text-zinc-800 line-clamp-1">
              {{ news.title }}
            </h3>
          </div>
          @if (news.content) {
          <p class="text-sm text-zinc-400 line-clamp-2 font-medium">
            {{ stripHtml(news.content) }}
          </p>
          }
        </div>
        <span class="text-sm text-zinc-800 font-medium shrink-0">
          {{ news.displayDate || news.createdAt | date : 'yyyy.MM.dd' }}
        </span>
      </div>
    </div>
    } @if (newsList().length === 0) {
    <app-not-found [(query)]="query" [isLoading]="$newsData.isLoading()">
      <span class="sb-aggro text-zinc-800 text-lg font-light">보도자료가 없습니다.</span>
    </app-not-found>
    }
  </div>

  <!-- 페이지네이션 -->
  @if (newsList().length > 0) {
  <app-pagination
    [currentPage]="currentPage()"
    [totalPages]="totalPages()"
    (pageChange)="onPageChange($event)"
    class="flex" />
  }
</div>
